
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/idealni-najemce",
      function () {
        return require("private-next-pages/idealni-najemce/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/idealni-najemce"])
      });
    }
  